import React, { useEffect, useState } from "react";
import "../Timer/timer.scss";
import Menu from "../../assets/images/Menu.png";
import {use} from "react";

export default function Timer({show,heading,startEvent,stopEvent,pauseEvent,resumeEvent,timerData,forceStart,resetTimer,btnText}) {

    const [startTime, setStartTime] = useState(() => localStorage.getItem("startTime") || null);
    const [pausedTime, setPausedTime] = useState(() => localStorage.getItem("pausedTime") || null);
    const [secondsElapsed, setSecondsElapsed] = useState(0);
    const [isRunning, setIsRunning] = useState(() => localStorage.getItem("isRunning") === "true");
    const [showTimer, setShowTimer] = useState(false);
    const local_keys = ['isRunning','startTime','pausedTime'];

    useEffect(() => {
        // setTimeout(()=>{
            local_keys.forEach((key) => { localStorage.removeItem(key); });
            console.log("localStorage cleared")
            stopTimer(false)
        // },1000)
    },[show])
    useEffect(() =>{
        
        if(timerData && timerData.status != undefined){
            // setStartTime(timerData.start_time);
            if(timerData.status === 'paused'){
                startTimer(timerData.adjust_start_time);
                pauseTimer(timerData.pause_time[timerData.pause_time.length-1]);
                const now = new Date(timerData.pause_time[timerData.pause_time.length-1]).getTime();
                const start = new Date(timerData.adjust_start_time).getTime();
                setSecondsElapsed(Math.floor((now - start) / 1000));
            }
            if(timerData.status === 'running'){
                  startTimer(timerData.adjust_start_time);
            }
            
        }
    },[timerData])

    useEffect(() => {
        if(resetTimer){
            local_keys.forEach((key) => { localStorage.removeItem(key); });
            stopTimer(false);
        }
    },[resetTimer]);
    useEffect(()=>{
        if(forceStart){
            startTimer(null);
        }
    },[forceStart])
    useEffect(() => {
        if (startTime && !pausedTime) {
            const now = new Date().getTime();
            const start = new Date(startTime).getTime();
            setSecondsElapsed(Math.floor((now - start) / 1000));
        } else if (pausedTime) {
            setIsRunning(false);
        }
    }, []);

    useEffect(() => {
        setShowTimer(show);   
    }, [show]);

    // useEffect(() => {
    //     localStorage.setItem("isRunning", isRunning);
    //     if (startTime) localStorage.setItem("startTime", startTime);
    //     if (pausedTime) localStorage.setItem("pausedTime", pausedTime);
    // }, [isRunning, startTime, pausedTime]);

    useEffect(() => {
        let timer;
        if (isRunning) {
            timer = setInterval(() => {
                if (startTime) {
                    const now = new Date().getTime();
                    const start = new Date(startTime).getTime();
                    setSecondsElapsed(Math.floor((now - start) / 1000));
                }
            }, 1000);
        } else {
            clearInterval(timer);
        }
        return () => clearInterval(timer);
    }, [isRunning, startTime]);

    const startTimer = (date=null) => {
        const now = (date == null ) ? new Date().toISOString() : date;
        setStartTime(now);
        setPausedTime(null);
        setIsRunning(true);
        if(date == null){
             startEvent(now);
        }
        localStorage.setItem("startTime", now);
        localStorage.removeItem("pausedTime");
    };

    const pauseTimer = (date=null) => {
        setIsRunning(false);
        const now = (date === null) ? new Date().toISOString() : date;
        setPausedTime(now);
        
        if(date == null){
             pauseEvent(now);
        }
        localStorage.setItem("pausedTime", now);
    };

    const resumeTimer = () => {
        if (pausedTime) {
            const pausedDuration = new Date().getTime() - new Date(pausedTime).getTime();
            const newStartTime = new Date(new Date(startTime).getTime() + pausedDuration).toISOString();
            setStartTime(newStartTime);
            setPausedTime(null);
            setIsRunning(true);
            localStorage.setItem("startTime", newStartTime);
            localStorage.removeItem("pausedTime");
            resumeEvent(newStartTime,new Date().toISOString());
            
        }
    };

    const stopTimer = (event) => {
        
        setIsRunning(false);
        setStartTime(null);
        setPausedTime(null);
        setSecondsElapsed(0);
        localStorage.removeItem("startTime");
        localStorage.removeItem("pausedTime");
        localStorage.removeItem("isRunning");
        if(event){
          stopEvent( new Date().toISOString());
        }
    };

    const formatTime = () => {
        const hrs = String(Math.floor(secondsElapsed / 3600)).padStart(2, "0");
        const mins = String(Math.floor((secondsElapsed % 3600) / 60)).padStart(2, "0");
        const secs = String(secondsElapsed % 60).padStart(2, "0");
        return `${hrs}:${mins}:${secs}`;
    };

    return (
        (showTimer) &&
        <div className='timer-details'>
            <div className='timer-top'>
                <div className='timer-left'>
                    <p>{heading}</p>
                    <h5>{formatTime()}</h5>
                </div>
                { isRunning || pausedTime ? (
                <div className='timer-menu'>
                    <button id="dropdownMoreMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                        <img src={Menu} className="img-fluid" alt="three-dot-image" />
                    </button>
                    <ul className="profile dropdown-menu" aria-labelledby="dropdownMoreMenu2">
                        {isRunning ? (
                            <li><a className="dropdown-item" href="#"><span className="item_text" onClick={()=>pauseTimer(null)}>Pause</span></a></li>
                        ) : pausedTime ? (
                            <li><a className="dropdown-item" href="#"><span className="item_text" onClick={resumeTimer}>Resume</span></a></li>
                        ) : null}
                    </ul>
                </div>
                ) : null}
            </div>
            {!isRunning && !pausedTime ? (
                <button className='start-trip tm-btn' onClick={()=>startTimer(null)}>Start {btnText}</button>
            ) : (
                <button className='end-trip tm-btn' onClick={()=>stopTimer(true)}>End {btnText}</button>
            )}
        </div>
    );
}
